module.exports = __webpack_public_path__ + "img/logo-bk.eb6c06cb.svg";